import { IRcaEditData } from "../interfaces/rca/IRcaEditData"
import { UPDATE_RCA_COACH_DATA, UPDATE_RCA_USER_HEADER_DATA } from "../constants/actionTypes"

function init() {
	return {
		userData: null,
		coachData: null,
		finalModalScreen: null,
	} as IRcaEditData
}

export const rcaEditDataReducer = (state = init(), action: any): IRcaEditData => {
	switch (action.type) {
		case UPDATE_RCA_USER_HEADER_DATA:
			return {
				...state,
				userData: action.userData,
			}
		case UPDATE_RCA_COACH_DATA:
			return {
				...state,
				coachData: action.coachData,
			}
		default:
			return state
	}
}
